import { useLocalStorage } from '@vueuse/core';

const useNativeBrowserScaling = useLocalStorage('useNativBrowserScaling', false);

const useAvatarState = () => ({
  useNativeBrowserScaling
});

export default useAvatarState;
